module.exports = __webpack_public_path__ + "static/img/60.3718ce4.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_right_icon/60.png
// module id = 3zkR
// module chunks = 1